import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { MdmLibModule } from 'app/mdm/lib/mdm-lib.module';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';
import { ObservationGroupListComponent } from 'app/mdm/terminology/observation-group/containers/observation-group-list.component';
import { ObservationGroupEditComponent } from 'app/mdm/terminology/observation-group/containers/observation-group-edit.component';

export const OG_ROUTES: Routes = [
  { path: '', component: ObservationGroupListComponent },
  { path: 'add', component: ObservationGroupEditComponent },
  { path: 'edit/:id', component: ObservationGroupEditComponent },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    FormsModule,
    TerminologyLibModule,
    ReactiveFormsModule,
    MdmLibModule,
  ],
  declarations: [ObservationGroupListComponent, ObservationGroupEditComponent],
})
export class ObservationGroupModule {}
